import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { replace } from 'connected-react-router'

import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { AVAILABILITY_REQUEST } from '../../../utils/constants'

import { formStepGo, formSubmit, formUpdate } from '../../../actions/requestFormActions'

import RequestFormContainer from './Container'

const validationSchema = [
  Yup.object().shape({
    facilityId: Yup.string().required('Facility is required')
  }),

  Yup.object().shape({
    dateStart: Yup.string().nullable().required('Date selection is required!'),
    stayLength: Yup.number()
      .min(0, '1 night or more')
      .max(14, '14 nights or under.')
      .required('Stay Length is required')
  }),

  Yup.object().shape({
    length: Yup.number().typeError('Enter a number in feet'),
    matchingSitesCount: Yup.number().min(1, 'No matching sites. Adjust filters above.')
  }),

  Yup.object().shape({
    email: Yup.string().required('Please enter your email address').email('Please enter your email address')
  })
]

const RequestForm = () => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(store => store.session.isAuthenticated)

  const currentStep = useSelector(store => store.requestForm.step)

  const goStep = step => {
    if (step === 1) {
      dispatch(formStepGo(1))
      dispatch(replace('/new'))
    } else {
      dispatch(formStepGo(step))
    }
  }
  const requestFormRef = useRef()

  useEffect(() => dispatch({ type: 'REQUEST_FORM_REF', payload: requestFormRef }))

  return (
    <div className="mb-24">
      <Formik
        innerRef={requestFormRef}
        initialValues={AVAILABILITY_REQUEST.initialValues}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={validationSchema[currentStep - 1]}
        onReset={values => {}}
        onSubmit={(values, { setSubmitting, ...props }) => {
          if (currentStep === 1) {
            dispatch(formStepGo(2)).then(() => setSubmitting(false))
          } else if (currentStep === 2) {
            values.uuid && dispatch(formUpdate(values)).then(() => setSubmitting(false))
            dispatch(formStepGo(3)).then(() => setSubmitting(false))
          } else if (!isAuthenticated && !values.uuid && currentStep === 3) {
            dispatch(formStepGo(4)).then(() => setSubmitting(false))
          } else {
            values.uuid
              ? dispatch(formUpdate(values, true)).then(() => setSubmitting(false))
              : dispatch(formSubmit(values)).then(() => setSubmitting(false))
          }
        }}
      >
        <Form>
          <RequestFormContainer goStep={goStep} />
        </Form>
      </Formik>
    </div>
  )
}

export default RequestForm
